import React from 'react'

function Button(props) {
  return (
    <button>{props.text}</button>
  )
}

export default Button

